import React from "react";
import { CFormText } from "@coreui/react";

export function ErrorList({ errors }) {
  if (errors && typeof errors == "object") {
    return Object.entries(errors).map((error, index) => {
      return (
        <CFormText className="help-block" key={index}>
          {Array.isArray(error[1])
            ? `* ${error[0]} ${error[1]}`
            : `* ${error[1].message ?? error[1]}`}
        </CFormText>
      );
    });
  }

  if (typeof errors === "string") {
    return <CFormText className="help-block">{errors}</CFormText>;
  }

  return null;
}
